import { InvestmentsServicesTariffsPage } from "@nvb/ui";
import { usePageContext } from "vike-react/usePageContext";

import type { CommissionResponse, IDocumentsApiResponse } from "@nvb/ui";

/**
 * Commission tables and tariff documents both came from browser-only fetches,
 * so the prerendered HTML held neither — and a failed request left the visitor
 * with a bare error line. The build-time snapshots travel in
 * `pageContext.initialData` (see `pages/+onBeforeRender.ts`); both hooks still
 * revalidate on mount.
 */
export default function Page() {
	const { initialData } = usePageContext();

	const commissions = initialData?.commissions as CommissionResponse | undefined;
	const documents = initialData?.documents as IDocumentsApiResponse | undefined;

	return (
		<InvestmentsServicesTariffsPage
			{...(commissions ? { initialData: commissions } : {})}
			{...(documents ? { initialDocuments: documents } : {})}
		/>
	);
}
